import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { SVG_STROKE_WIDTH, ANGLE_0, defaultProps, BarIndicatorSize, CircularIndicatorSize } from './constants.js';
import { strokeDasharray } from './util.js';

const lookupSize = ({ size: propSize, type }) => {
    const size = propSize !== null && propSize !== void 0 ? propSize : defaultProps.size;
    return typeof size === 'number'
        ? rem(size)
        : type === 'bar'
            ? BarIndicatorSize[size]
            : CircularIndicatorSize[size];
};
const IndicatorBaseStyle = css `
    display: inline-flex;
    height: ${lookupSize};
    width: ${lookupSize};

    &[data-type='bar'] {
        display: flex;
        width: auto;
    }
`;
const Indicator = styled.svg `
    flex-grow: 1;
`;
const Path = styled.path `
    fill: none;
    stroke: currentcolor;
    stroke-dasharray: ${strokeDasharray};

    /* SVG strokes are centered on the path line, in this case on the perimeter
       of the circle. Because we want that the whole stroke width is within
       the circle, we duplicate the width here and then use a clipPath to cut
       out the outer half that exceeds the dimensions of the circle. */
    stroke-width: ${2 * SVG_STROKE_WIDTH};
`;
Path.defaultProps = {
    strokeAngle: ANGLE_0,
};
const PrimaryPath = styled(Path) ``;
const SecondaryPath = styled(Path) ``;

export { Indicator, IndicatorBaseStyle, Path, PrimaryPath, SecondaryPath };
//# sourceMappingURL=IndicatorBase.styles.js.map
